// Action example: ?gmf_action=comment:create(product_review,B017382)

import openCommentFormV2 from "@/components/CommentFormV2";
import openPostModal from '@/widgets/PostModal/openPostModal';
import openSocialModal from '@/widgets/SocialFeed/openSocialModal';
import openPopupProfileCard from "@/components/PopupProfileCard/openPopupProfileCard";

const actions = {
    'comment:create'([commentType, targetId], { token, product_score }) {
        openCommentFormV2(commentType, targetId, null, true, { token, product_score });
    },
    'comment:show'([commentId]) {
        openPostModal(commentId);
    },
    'user:show'([merchantCustomerId, tab]) {
        openPopupProfileCard(merchantCustomerId, tab);
    },
    'socialFeed:open'(args, { board, type }) {
        let filter = null;

        if (board) {
            filter = {
                board_id: board,
            };
        }

        if (type) {
            filter = {
                type: type,
            };
        }

        openSocialModal({
            displayHeader: true,
            filter,
        });
    },
};

export async function runQueryActions() {
    // parse url query
    const urlParams = new URLSearchParams(window.location.search);
    const query = urlParams.get('gmf_action');

    if (!query) return;

    const action = query.split('(').map(s => s.trim())[0];

    const argsUnsplit = query.split('(')[1];

    if (!argsUnsplit) return;

    const args = argsUnsplit.split(')')[0].split(',').map(arg => arg.trim());
    const namedArgs = {};

    // extract named args
    for (let i = 0; i < args.length; i++) {
        const arg = args[i];
        const [key, value] = arg.split('=');
        if (!value) continue;
        namedArgs[key.trim()] = value.trim();

        // remove named args from args
        args.splice(i--, 1);
    }

    if (!actions[action]) {
        console.error('Unknown action', action);
        return;
    }

    actions[action](args, namedArgs);
}
